import React from 'react';
import { SvgIcon } from '@mui/material';
import { shape } from 'prop-types';

const SwiftLogoColored = props => (
  <SvgIcon classes={props.classes} viewBox="0 0 71 92">
    <g fill="#213657" fillRule="evenodd" id="Final-Pages" stroke="none" strokeWidth="1">
      <g fillRule="nonzero" id="Pre-login-Circular" transform="translate(-605.000000, -144.000000)">
        <g id="swiftlogo_logomark_fullcolor" transform="translate(605.000000, 144.000000)">
          <path
            d="M0.155180723,53.1992771 L1.72301409e-15,36.6725301 C-0.00838260466,36.4624231 0.0768770031,36.259424 0.232771084,36.1183133 L39.2718072,0.277108434 C39.5415901,0.0352191343 39.9203873,-0.0433800585 40.2641371,0.0712032012 C40.6078869,0.185786461 40.8637651,0.475944135 40.9344578,0.831325301 C41.3224096,2.76 42.2978313,10.4857831 42.9407229,15.5679518 C43.2749823,18.4528674 42.2512599,21.3295273 40.1696386,23.3546988 L22.0190361,41.266988 C21.8526284,41.4204556 21.7666403,41.6423148 21.7861572,41.867843 C21.805674,42.0933711 21.928497,42.2971602 22.1187952,42.419759 L34.633012,49.9737349 C34.8644727,50.113179 35.0191588,50.3511108 35.0526755,50.6192439 C35.0861921,50.8873769 34.9948334,51.1560643 34.8048193,51.3481928 L20.8496386,65.2590361 C20.566901,65.5502616 20.1196412,65.6055927 19.7744578,65.3920482 L0.504337349,53.82 C0.286676647,53.6891001 0.154019178,53.4532646 0.155180723,53.1992771 Z"
            fill="#3B9063"
            id="Path"
          />
          <path
            d="M70.3744578,38.606747 L70.5240964,55.1390361 C70.532479,55.3491431 70.4472194,55.5521422 70.2913253,55.693253 L31.1691566,91.54 C30.8993737,91.7818893 30.5205765,91.8604885 30.1768268,91.7459052 C29.833077,91.631322 29.5771987,91.3411643 29.506506,90.9857831 C29.1684337,89.0571084 28.159759,81.2925301 27.5612048,76.2713253 C27.2133026,73.4047418 28.2143108,70.5388696 30.2713253,68.5122892 L48.4607229,50.5279518 C48.6150257,50.3649947 48.6866857,50.1406181 48.655401,49.9183893 C48.6241164,49.6961604 48.4932953,49.5002885 48.3,49.3862651 L35.8024096,41.8489157 C35.570756,41.709007 35.4168079,41.469849 35.3853764,41.2010556 C35.3539449,40.9322622 35.4485621,40.6640381 35.6416867,40.4744578 L49.6245783,26.5525301 C49.9040655,26.2628682 50.348679,26.2096072 50.6886747,26.4250602 L69.9698795,37.9860241 C70.2012001,38.1110171 70.3534817,38.3446545 70.3744578,38.606747 L70.3744578,38.606747 Z"
            fill="#1D6337"
            id="Path-2"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

SwiftLogoColored.propTypes = {
  classes: shape({}),
};

SwiftLogoColored.defaultProps = {
  classes: {},
};

export default SwiftLogoColored;
